import { Fragment, useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { formatDateTime, formatQty } from "./inventoryUtils";
//--------------------------------------------------------------------------------------------
export default function InventoryHistoryModal({ closeIt, logs, loading }){
    const [page, setPage] = useState(1);
    const pageSize = 25;
    const totalPages = Math.max(1, Math.ceil(logs.length / pageSize));
    const currentPage = Math.min(page, totalPages);
    const startIndex = (currentPage - 1) * pageSize;
    const pageLogs = logs.slice(startIndex, startIndex + pageSize);
    useEffect(() => { setPage(1); }, [logs]);
    const describeLog = log => {
        if(log.movementType === "receive") return `Added to ${log.destinationYardName || "yard"}`;
        if(log.movementType === "transfer") return `${log.sourceYardName || "Yard"} → ${log.destinationYardName || "Yard"}`;
        if(log.movementType === "issue") return `${log.sourceYardName || "Yard"} → ${log.destinationUserName || log.destinationUserEmail || "User"}`;
        return log.movementType;
    };
    return <Modal title = "Inventory Movement History" closeIt = {closeIt} width = "78rem" maxWidth = "98%" formFormat = "">
        <div className = "inventoryModalBody">
            {loading?<div className = "cssLoading">Loading movement history...</div>:
            !logs.length?<div className = "cssLoading">No movement history yet.</div>:
            <Fragment>
                <div className = "inventoryHistoryTableWrap">
                    <table className = "inventoryHistoryTable">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Item</th>
                                <th>Qty</th>
                                <th>Movement</th>
                                <th>Runner</th>
                                <th>PO</th>
                                <th>Notes</th>
                                <th>By</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pageLogs.map(log => <tr key = {log.id}>
                                <td>{formatDateTime(log.createdAt)}</td>
                                <td>{log.itemName}</td>
                                <td>{formatQty(log.quantity)} {log.unit || ""}</td>
                                <td>{describeLog(log)}</td>
                                <td>{log.runnerName || log.runnerEmail || "—"}</td>
                                <td>{log.poNumber || "—"}</td>
                                <td>{log.notes || "—"}</td>
                                <td>{log.createdByName || log.createdBy || "—"}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <div className = "inventoryHistoryPager">
                    <span>Showing {startIndex + 1}-{Math.min(startIndex + pageSize, logs.length)} of {logs.length}</span>
                    <div>
                        <button type = "button" className = "btn btn-outline-secondary btn-sm" disabled = {currentPage <= 1} onClick = {() => setPage(currentPage - 1)}>Previous</button>
                        <span className = "inventoryHistoryPageLabel">Page {currentPage} of {totalPages}</span>
                        <button type = "button" className = "btn btn-outline-secondary btn-sm" disabled = {currentPage >= totalPages} onClick = {() => setPage(currentPage + 1)}>Next</button>
                    </div>
                </div>
            </Fragment>}
        </div>
    </Modal>;
}
